import SearchForm from "../../components-contabilidad-analisis/SearchForm"
import SearchField from "../../c&m/facturacion/searchField"
import PreviewImage from "../../c&m/productos/PreviewImage"

function classNames(...classes) {
    return classes.filter(Boolean).join(' ') 
}

const GridItemsProductos = ({ col=false , data, handleQuery, addProduct, centro=0, isFormik = true, setQuery, query, label, values }) => {

    return(
        <div className={classNames(centro?" h-[300px]":"","px-4 sm:px-6 lg:px-8 p-5 pb-0")}>
            <div className="flex items-center flex-col lg:flex-row w-full justify-between">
                <div className={col?"/sm:flex-auto flex w-3/4 flex-col " : "/sm:flex-auto flex w-1/2 flex-col"}>
                    <h1 className="text-lg font-semibold text-white flex ">{`2. Seleccionar ${centro?`servicios`:`productos`}`}</h1>
                     <p className="mt-0 text-sm text-grisMira flex ">
                        {label}
                    </p>
                </div>

                <div className={col? "pt-0 lg:ml-11 lg:mt-0 w-full " : "pt-0 lg:ml-11 lg:mt-0 w-1/4 "}>
                    {
                        !isFormik 
                        ?
                            <SearchField
                                handleQuery={handleQuery}
                                setQuery={setQuery}
                                query={query}
                            />
                        :
                            <SearchForm
                                handleQuery={handleQuery}
                            />
                    }
                </div>

            </div>
            <div className={classNames(centro?"mt-2":"mt-8", "flex flex-col px-6 pb-3")}>
                <div className="-mx-4 sm:-mx-6 lg:-mx-8 overflow-auto">
                <div className="inline-block min-w-full align-middle h-[24rem]">
                    <div className="">
                    <table className="min-w-full border-separate" style={{ borderSpacing: 0 }}>
                        <thead className="bg-secundarioMira">
                            <tr>
                                <th
                                scope="col"
                                className={classNames(centro? "hidden": "sticky" , "top-0 z-10 bg-secundarioMira border-b border-gray-300 py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-grisMira sm:pl-6 lg:pl-8")}
                                >
                                    Producto
                                </th>
                                <th
                                scope="col"
                                className={classNames(centro? "hidden" : "sticky", "top-0 z-10 bg-secundarioMira border-b border-gray-300 py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-grisMira sm:pl-6 lg:pl-8")}
                                >
                                    Id Producto
                                </th>
                                <th
                                scope="col"
                                className="sticky top-0 z-10 bg-secundarioMira  border-b border-gray-300 px-3 py-3.5 text-left text-sm font-semibold text-grisMira "
                                >
                                    Descripción
                                </th>
                                <th
                                scope="col"
                                className="sticky top-0 z-10 border-b border-gray-300 py-3.5 pr-4 pl-3 bg-secundarioMira sm:pr-6 lg:pr-8"
                                >
                                <span className="sr-only">Agregar</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody className="bg-secundarioMira">
                        {data.map((producto, Idx) =>   
                                <tr 
                                    key={Idx}
                                    onClick={() => addProduct(centro, producto)}
                                    className='cursor-pointer hover:bg-primarioMira'
                                >
                                    <td
                                        className={classNames(centro? "hidden":
                                        Idx !== data.length - 1 ? 'border-b-2 border-b-primarioMira' : '',
                                        'whitespace-nowrap py-2 pl-4 pr-3 text-sm font-medium text-white sm:pl-6 lg:pl-8'
                                        )}
                                    >
                                        <div className="flex content-center gap-3">
                                            <PreviewImage
                                                file={producto.Imagen}
                                                className='h-11 w-11 object-cover rounded-lg'
                                            />
                                        </div>
                                    </td>
                                    <td
                                        className={classNames(centro? "hidden":
                                        Idx !== data.length - 1 ? 'border-b-2 border-b-primarioMira' : '',
                                        'whitespace-nowrap py-2 pl-4 pr-3 text-sm font-medium text-white sm:pl-6 lg:pl-8'
                                        )}
                                    >
                                        {producto.IdProducto}
                                    </td>
                                    <td
                                        className={classNames(
                                        Idx !== data.length - 1 ? 'border-b-2 border-b-primarioMira' : '',
                                        '/whitespace-nowrap px-3 py-2 text-sm text-white w-3/4'
                                        )}
                                    >
                                        {producto.Descripcion}
                                        {
                                            producto.Global ?
                                                <span
                                                    className="bg-green-500/80 px-2 py-1 ml-2 rounded-full font-semibold text-xs"
                                                >
                                                    Global
                                                </span>
                                            : null
                                        }
                                    </td>
                                    <td
                                        className={classNames(
                                        Idx !== data.length - 1 ? 'border-b-2 border-b-primarioMira' : '',
                                        'relative whitespace-nowrap py-2 pr-4 pl-3 text-right text-sm font-medium sm:pr-6 lg:pr-8'
                                        )}
                                    > 
                                        <button
                                            type="button"
                                            className="text-secundario hover:underline"
                                        >
                                            Agregar
                                            <span className="sr-only">, {producto.name} </span>
                                        </button>
                                    </td>
                                </tr>
                        )}
                        </tbody>
                    </table>
                    </div>
                </div>
                </div>
            </div>
        </div>
    )
}

export default GridItemsProductos